import type { DbmsInfo } from '@nx/state/desktop';
import { DBMS_STATUS } from '@nx/state/desktop';
import { isNullish } from '@nx/stdlib';
import { memo } from 'react';

import { InstanceCardHeader, InstanceCardWrapper } from '../../components/instance-card-wrappers';
import type { InstanceDetailsTab } from '../instance-details';
import { InstanceCardHeaderWithControls } from './header';
import { DatabaseList } from './instance-database-list';
import { InstanceInfo } from './instance-info';
import { InstanceStatusLabel, InstanceStatusLabelLoading } from './instance-status-label';

interface InstanceCardProps {
  instance: DbmsInfo;
  onInstanceDetailsClick: (initialTab?: InstanceDetailsTab) => void;
  onConnectionSuccess?: () => void;
  isCompact?: boolean;
}

export const InstanceCardComponent = ({
  instance,
  onInstanceDetailsClick,
  onConnectionSuccess,
  isCompact = false,
}: InstanceCardProps) => {
  if (isNullish(instance)) {
    return null;
  }

  if (instance.progressStatus === 'cloning') {
    return (
      <InstanceCardWrapper>
        <InstanceCardHeader instanceName={instance.name} />
        <InstanceStatusLabelLoading label="Cloning" />
      </InstanceCardWrapper>
    );
  }

  return (
    <InstanceCardWrapper isHighlighted={DBMS_STATUS.STARTED === instance.status}>
      <InstanceCardHeaderWithControls
        instance={instance}
        onInstanceDetailsClick={onInstanceDetailsClick}
        onConnectionSuccess={onConnectionSuccess}
        isCompact={isCompact}
      />
      <InstanceStatusLabel instance={instance} />
      <InstanceInfo instance={instance} />

      {!isCompact && <DatabaseList instance={instance} />}
    </InstanceCardWrapper>
  );
};

export const InstanceCard = memo(InstanceCardComponent);
